import {
  BENEFITS_INTERACTION,
  JOB_AD_DETAILS_ITEM_PRESSED,
  LINK_ACTION_ADD,
  LINK_ACTION_REMOVE,
  QUALIFICATIONS_INTERACTION,
  RESPONSIBILITIES_INTERACTION,
} from 'src/app/shared/dataAnalytics/schema/constants';
import type { TrackingEvent } from 'src/types/trackingData';

export const responsiblitiesOnBlurNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: RESPONSIBILITIES_INTERACTION,
  linkAction: LINK_ACTION_ADD,
};
export const qualificiationsOnBlurNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: QUALIFICATIONS_INTERACTION,
  linkAction: LINK_ACTION_ADD,
};
export const benefitsOnBlurNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: BENEFITS_INTERACTION,
  linkAction: LINK_ACTION_ADD,
};
export const responsibilitiesOnRemovedNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: RESPONSIBILITIES_INTERACTION,
  linkAction: LINK_ACTION_REMOVE,
};
export const qualificationsOnRemovedNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: QUALIFICATIONS_INTERACTION,
  linkAction: LINK_ACTION_REMOVE,
};
export const benefitsOnRemovedNewTrackingEvent: TrackingEvent = {
  eventName: JOB_AD_DETAILS_ITEM_PRESSED,
  objectInteraction: BENEFITS_INTERACTION,
  linkAction: LINK_ACTION_REMOVE,
};
